import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import {
	Button,
	Grid,
	Stack,
	TextField,
	FormControlLabel,
	Select,
	FormControl,
	Box,
	Typography
} from '@mui/material';
import { dashboardUrl } from '../../../service/config';
import './Summary.scss';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useSearchParams } from 'react-router-dom';
import { ReactComponent as DatePickerIcon } from '../../../assets/calendar-outline_white.svg';
import { ReactComponent as FilterIcon } from '../../../assets/ml_summary_filter.svg';
import { ReactComponent as ServerIcon } from '../../../assets/solar_server-outline.svg';
import { getDecodedToken, getSector } from '../../../service/service';
import useStyles from '../../jobs/jobs_styles';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import { useTheme } from "@mui/material/styles";

const AnalyticsVisualization = lazy(() => import('../../framework/analyticsVisualization'));
const Workbooks = lazy(() => import('./Workbooks'));
const TableauUsers = lazy(() => import('./Users'));


const TableauSummary = () => {	
	const theme= useTheme();
	const colors = theme.palette;
	const [searchParams, setSearchParams] = useSearchParams();
	const hasDrillDown = searchParams.has('isDrillDowned');
	const dateFrom: string = searchParams.get('fromDate')?.substring(0, 10) as string;
	const startDt = moment(dateFrom).startOf('day').subtract(1, 'hours').format('YYYY-MM-DD');
	const [fromDateTime, setFromDateTime] = useState<any>(
		searchParams.has('fromDate') ? startDt : moment().startOf('day').subtract(1, 'hours')
	);

	
	const [propsFromDateTime, setPropsFromDateTime] = useState<any>(
		searchParams.has('fromDate') ? startDt : moment().startOf('day').subtract(1, 'hours')
	);
	
		// sector filter
		const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
		const [filterMenu, setFilterMenu] = useState<{
			mouseX: number;
			mouseY: number;
		} | null>(null);
		const classes = useStyles();
		const [itemsChecked, setItemsChecked] = useState(false);
		const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
		const [checkedList, setCheckedList] = useState<any[]>([]);
		const [currSectorFilter, setCurrSectorFilter] = useState<any[]>([]);
		const [currSector, setCurrSector] = useState<any[]>([]);
		const dataFetchedRef = useRef(false);

		// server filter
		const [instance, setInstance] = useState<any>('all');
	
	const handleDateTimeChange = (field: any, dateTime: any) => {
		localStorage.setItem('selectedDateTime', dateTime);// Tableau drilldown filter changes
		if (field === 'fromDateTime') setFromDateTime(dateTime);
		// else setToDateTime(dateTime);
		applyDateTimeRange(dateTime);
	};

	const resetSearchParams = () => {
		if (searchParams.has('fromDate')) {
			searchParams.delete('status');
			searchParams.delete('scheduleDate');
			searchParams.delete('fromDate');
			setSearchParams(searchParams);
		}
	};
	const applyDateTimeRange = (dateTime: any) => {
		setPropsFromDateTime(dateTime);
		resetSearchParams();
	};
	const sectorFilterClick = (event: any) => {
		event.preventDefault();
		setFilterMenu(
			filterMenu === null
				? {
						mouseX: Number.parseInt(event.clientX) - 20,
						mouseY: Number.parseInt(event.clientY) - 6
				  }
				: null
		);
	};

	const handleClose = (event: any) => {
		setFilterMenu(null);
	};

	const selectAllCheck = (e: any) => {
		const { checked } = e.target;
		const collection: any[] = [];
		if (checked) setCheckedList(sectorOptionsList);
		else setCheckedList([]);
		setItemsChecked(checked);
	};

	const handleChange = (e: any) => {
		const { value, checked } = e.target;
		const newlyChecked = [];
		if (checked && e.target.value) {
			newlyChecked.push(e.target.value);
		}
		if (checked) {
			setCheckedList([...checkedList, ...newlyChecked]);
			if(sectorOptionsList.length === (checkedList.length + newlyChecked.length)){
				setItemsChecked(true);
			}
		} else {
			setCheckedList(checkedList.filter((item) => item !== value));
			setItemsChecked(false);
		}
	};
	const handleOkClick = (event: any) => {
		localStorage.setItem('selectedSector', JSON.stringify(checkedList)); // Tableau drilldown filter changes
		if (checkedList.length > 0) {
			setCurrSectorFilter(checkedList);
		} else {
			setCurrSectorFilter([]);
		}
		setCurrSector( checkedList );
		// DBWorkspaceSpentListingFunc(page, pageSize, sortingInfo, fromDateTime, toDateTime, parseFilter(filterInfo), checkedList);
		// updateSharedValue({ sectorFilter: checkedList });
		// localStorage.setItem('dcs-summary-sector-filter', JSON.stringify(checkedList));
		handleClose(event);
	};

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			const filteredSectorOptions = sectorRes.data.sector.filter((x: any) => x.name !== 'S&T').map((x: any) => x.name);
			filteredSectorOptions.push('Blank');
        	setSectorOptionsList(filteredSectorOptions);
		}
	}
	const [serverFilter, setServerFilter] = useState<any>('all');

	// Server filter code
	const handleServerChange = (field: any, selectedServer: any) => {
		// Tableau server filter changes
		localStorage.setItem('selectedServer', selectedServer.target.value);
		if (field === 'instance') setInstance(selectedServer.target.value);
		applyServerFilter(selectedServer.target.value, selectedServer.target.value);
	};

	const applyServerFilter = (selectedServer: any, instanceReVal: any) => {
		setInstance(selectedServer);	
		setServerFilter(instanceReVal);
		resetSearchParams();
};
	
	const handleDrillDownFilters = () => {
		const selectedDateTime = localStorage.getItem('selectedDateTime');
		if (selectedDateTime) {
			setFromDateTime(selectedDateTime);
			setPropsFromDateTime(selectedDateTime);
		}

		const selectedSector = localStorage.getItem('selectedSector');
		if (selectedSector) {
			const parsedSector = JSON.parse(selectedSector);
			const selectedSec = parsedSector?.length ? parsedSector : '';
			setCheckedList(selectedSec);
			setCurrSectorFilter(selectedSec);
		}

		const selectedServer = localStorage.getItem('selectedServer');
		if (selectedServer) {
			setInstance(selectedServer);
		}
	};

	const clearDrillDownFilters = () => {
		[
			'selectedDateTime',
			'selectedFilter',
			'selectedSector',
			'selectedServer'
		].forEach((key) => localStorage.removeItem(key));
	};

	const updateTableauDashboardClasses = () => {
		const activeId = document.getElementById('root');
		const isTableauDashboard =
			window.location.pathname === '/tableau/summary/dashboard';

		if (isTableauDashboard) {
			activeId?.classList.add('jobs-list-table');
			activeId?.classList.remove('jobs-list', 'root');

			document.body.classList.add(
				'jobs-exe-datas',
				'jobs-list-datas',
				'databricks-jobs',
				'datefilter-align-sector',
				'sector-label'
			);

			document.body.classList.remove('jobs-run-table');
			return;
		}

		document.body.classList.remove(
			'jobs-list-datas',
			'jobs-run-table',
			'jobs-exe-datas'
		);

		activeId?.classList.add('root');
		activeId?.classList.remove('jobs-list-table', 'jobs-list');
	};

	useEffect(() => {
		if (hasDrillDown) {
			handleDrillDownFilters();
		} else {
			clearDrillDownFilters();
		}

		if (dataFetchedRef.current) return;

		dataFetchedRef.current = true;

		if (userSector === 'all') {
			fetchSectorOptionsData();
		}

		updateTableauDashboardClasses();
	}, []);

	const getFilterDisplayValue = (filter: any) => {
		if (filter === true) return 'Yes';
		if (filter === false) return 'No';

		return filter;
	};

	console.log(propsFromDateTime, 'propsFromDateSummary')
	let fromDate = moment(propsFromDateTime).format('YYYY-MM-DD');
	console.log(fromDate, 'fromDateSummary')
	return (
		<div className="dashboard-panel job-schedules-wrap">
			<Stack
				direction="row"
				spacing={2}
				justifyContent="flex-end"
				alignItems="center"
				sx={{ mt: 10 }}
			>
      {/* Date Range Filter */}
      <Box sx={{ backgroundColor: colors.backgroundLight.dark, borderRadius: 1, p: 1 }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            showToolbar
            components={{ OpenPickerIcon: DatePickerIcon }}
            PopperProps={{
				placement: "auto",
				sx: {
					"& .MuiPaper-root": {
						backgroundColor: `${colors.dropdown.background} !important`,
					},
					"& .MuiPickersDay-root": {
						color: `${colors.dropdown.menuItemHoverText} !important`,
						"&.Mui-selected": {
						backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
						},
						"&:hover": {
						backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
						},
					},
					"& .MuiTypography-root": {
						color: `${colors.dropdown.menuItemHoverText} !important`,
					},
				},
			}}
            value={moment(fromDateTime).tz("America/New_York")}
            onChange={(dateTime) => handleDateTimeChange("fromDateTime", dateTime)}
            renderInput={(params: any) => (
              <TextField
                name="startDateTime"
                {...params}
                size="small"
                sx={{ "& .MuiInputBase-root": { 
					...theme.typography.filterText,
					height: 36 
				} }}
              />
            )}
          />
        </LocalizationProvider>
      </Box>

      {/* Sector Filter */}
      <Box sx={{ backgroundColor: colors.backgroundLight.dark, borderRadius: 1, display: "flex", alignItems: "center" }}>
        {userSector === "all" ? (
          <FilterIcon onClick={sectorFilterClick} />
        ) : (
          <Typography variant='filterText' sx={{ px: 1 }}>Sector: {getDecodedToken()?.sector?.name}</Typography>
        )}
        <Popover
          open={filterMenu !== null}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            filterMenu !== null
              ? { top: filterMenu.mouseY, left: filterMenu.mouseX }
              : undefined
          }
        >
          <Stack spacing={1} sx={{ 
				backgroundColor: `${colors.dropdown.menuItemBackground} !important`, 
				p: 2,
				maxHeight: 250,
      			overflowY: "auto",
			}}>
            <MenuItem 
			selected={itemsChecked}
			sx={{
				...theme.typography.filterText,
					backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
					color: `${colors.dropdown.menuItemText} !important`,
					'&:hover': {
						backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					'& .MuiFormControlLabel-label': {
						color: `${colors.dropdown.menuItemHoverText} !important`,
					},
				},
			}}>
              <FormControlLabel
                label={<Typography variant="filterText">All</Typography>}
				sx={{
					'& .MuiFormControlLabel-label': {
						color: `${colors.dropdown.menuItemText} !important`,
					},
				}}
                control={
                  <Checkbox
                    color="success"
                    value="all"
                    checked={itemsChecked}
                    onChange={(e) => selectAllCheck(e)}
					sx={{
						'& .MuiSvgIcon-root': {
						color: `${colors.dropdown.checkBox} !important`,
						},
					}}
                  />
                }
              />
            </MenuItem>
            <Stack>
              { sectorOptionsList?.map((filter: any) => (
                  <MenuItem key={filter} 
				  selected={checkedList.includes(filter)}
				  sx={{
					...theme.typography.filterText,
						color: `${colors.dropdown.menuItemText} !important`,
						 backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
							'&:hover': {
								backgroundColor: `${colors.dropdown.menuItemHover} !important`,
							'& .MuiFormControlLabel-label': {
								color: `${colors.dropdown.menuItemHoverText} !important`,
							},
						},
					}}>
                    <FormControlLabel
                      label={
						<Typography variant="filterText">
							{getFilterDisplayValue(filter)}
						</Typography>
					  }
					  sx={{
							'& .MuiFormControlLabel-label': {
								color: `${colors.dropdown.menuItemText} !important`,
							},
						}}
                      control={
                        <Checkbox
                          color="success"
                          value={filter}
                          checked={
                            (filter === true && checkedList.includes("true")) ||
                            (filter === false && checkedList.includes("false")) ||
                            checkedList.includes(filter)
                          }
                          onChange={(e) => handleChange(e)}
						  sx={{
							'& .MuiSvgIcon-root': {
							color: `${colors.dropdown.checkBox} !important`,
							},
						}}
                        />
                      }
                    />
                  </MenuItem>
                ))}
            </Stack>
			</Stack>
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button variant="contained" onClick={handleClose} className={classes.cancelBtn}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleOkClick} className={classes.okBtn}>
                Ok
              </Button>
            </Stack>
        </Popover>
      </Box>

      {/* Server Filter */}
      <Box
        sx={{
          backgroundColor: colors.backgroundLight.dark,
          borderRadius: 1,
		  p: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <FormControl fullWidth size="small">
          <Stack direction="row" alignItems="center" spacing={1}>
            <ServerIcon />
            <Select
              name="server-select"
              id="single-server-select"
              value={instance}
              onChange={(e) => handleServerChange("instance", e)}
              classes={{ select: classes.select }}
              IconComponent={() => null}
              sx={{ 
				minWidth: 120, 
				height: 36,
				"& .MuiSelect-select": {
					...theme.typography.filterText,
				},
			}}
			  MenuProps={{
					PaperProps: {
					sx: {
						backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
						color: `${colors.dropdown.menuItemText} !important`,
					},
					},
					MenuListProps: {
						sx: {
							p: 0,
						},
					},
				}}
            >
              <MenuItem
                value="all"
                sx={{
					backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
					color: `${colors.dropdown.menuItemText} !important`,
					"&.Mui-selected": {
					backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&.Mui-selected:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
				}}
              >
                All Servers
              </MenuItem>
              <MenuItem
                value="global"
                sx={{
					backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
					color: `${colors.dropdown.menuItemText} !important`,
					"&.Mui-selected": {
					backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&.Mui-selected:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
				}}
              >
                <Typography variant='filterText'>Global</Typography>
              </MenuItem>
              <MenuItem
                value="cockpit"
                sx={{
					backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
					color: `${colors.dropdown.menuItemText} !important`,
					"&.Mui-selected": {
					backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&.Mui-selected:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
					"&:hover": {
					backgroundColor: `${colors.dropdown.menuItemHover} !important`,
					color: `${colors.dropdown.menuItemHoverText} !important`,
					},
				}}
              >
                <Typography variant='filterText'>Cockpit</Typography>
              </MenuItem>
            </Select>
          </Stack>
        </FormControl>
      </Box>
    </Stack>
			<Suspense fallback={<div>Loading...</div>}>			
				<Stack>
					<AnalyticsVisualization
						params={{
							dashboardUrl: dashboardUrl.tableausummary,
							className: 'tableauSummaryIframeContainer',
							otherParams: {
								'var-fromDate': fromDate,
								'var-sector': currSectorFilter,
								'var-server': instance
							},
							seamless: true
						}}
					/>
				</Stack>
				<Grid id="workbooks" marginTop={2}>
					<Workbooks fromDateTime={propsFromDateTime} sectorFilter={currSector} serverFilter={serverFilter} />
				</Grid>
				<Grid id="users">
					<TableauUsers fromDateTime={propsFromDateTime}sectorFilter={currSector} serverFilter={serverFilter} />
				</Grid>
			</Suspense>
		</div>
	);
};

export default TableauSummary;
